module.exports = __webpack_public_path__ + "img/COZZI.79795840.jpg";